import { z } from 'zod';
/**
 * Phase 4.75b — public tracking links.
 *
 * Defaults:
 *   - expiresAt:     30 days from now (service computes; clients can override)
 *   - hard maximum:  90 days from now (rejected if exceeded)
 */
export const TRACKING_LINK_DEFAULT_TTL_DAYS = 30;
export const TRACKING_LINK_MAX_TTL_DAYS = 90;
const labelSchema = z.string().trim().min(1).max(80);
export const createTrackingLinkSchema = z.object({
    label: labelSchema.optional(),
    /**
     * Optional override of expiry. Must be in the future and ≤ 90 days from
     * now. Service layer enforces — schema accepts any future ISO timestamp.
     */
    expiresAt: z.string().datetime({ offset: true }).optional(),
});
export const trackingLinkIdParamSchema = z.object({
    linkId: z.string().length(26),
});
/** Public path param — `/track/:token`. The token isn't a ULID. */
export const trackingTokenParamSchema = z.object({
    token: z
        .string()
        .min(20)
        .max(64)
        // base64url alphabet
        .regex(/^[A-Za-z0-9_-]+$/, 'Invalid tracking token format'),
});
//# sourceMappingURL=tracking-link.js.map